import en from "@/locales/en";
import ar from "@/locales/ar";

const locales = {
  en: en,
  ar: ar,
}

export default locales